<div class="m-messages-wrapper">
  <m-messages
    *ngIf="showBanner"
    [messages]="messages"
    [closable]="true"
    (closeMessage)="handleClose()"
    styleClass="pt-6">
  </m-messages>
</div>
